import React from 'react';
import { ArrowDown } from '../../../public/icons';

const ProductTable = ({ products, onProductAction }) => {
  const getStatusBadge = (status) => {
    const statusConfig = {
      Active: {
        textColor: 'text-[#2F8F5B]',
        bgColor: 'bg-[#E7F4ED]',
        dotColor: 'bg-[#2F8F5B]'
      },
      Draft: {
        textColor: 'text-[#B8860B]',
        bgColor: 'bg-[#FFF9E6]',
        dotColor: 'bg-[#B8860B]'
      },
      Inactive: {
        textColor: 'text-[#8F342F]',
        bgColor: 'bg-[#F4E7E7]',
        dotColor: 'bg-[#8F342F]'
      }
    };

    const config = statusConfig[status] || statusConfig.Draft;

    return (
      <span className={`flex items-center gap-1.5 px-3 py-1.5 text-xs leading-5 font-semibold rounded-full ${config.bgColor}`}>
        <span className={`h-2 w-2 rounded-full ${config.dotColor}`} />
        <span className={config.textColor}>
          {status}
        </span>
        <ArrowDown size={12} className={config.textColor} />
      </span>
    );
  };

  return (
    <div className="overflow-x-auto text-left">
      <table className="min-w-full divide-y divide-[#DBDBDB]">
        <thead className="bg-[#F3F4F6]">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
              Product Name
            </th>
            <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
             Type of Product
            </th>
            <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
              Collection path
            </th>
            <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
              Price
            </th>
            <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
              Status
            </th>
            <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
              Action
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {products.map((product) => (
            <tr key={product.id} className="hover:bg-gray-50 transition-colors duration-150">
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="text-sm font-normal text-[#0E1628]">{product.name}</span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="text-sm font-normal text-[#0E1628]">{product.typeOfProduct}</span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="text-sm font-normal text-[#0E1628]">{product.collectionPath}</span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="text-sm font-normal text-[#0E1628]">{product.basePrice}</span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                {getStatusBadge(product.status)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <button
                  onClick={() => onProductAction(product.id, 'menu')}
                  className="text-[#6B635D] hover:text-[#1C2A46] transition-colors"
                >
                  <span className="text-lg font-bold">⋮</span>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;